import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import Carousel from 'react-material-ui-carousel';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import s from './CommentsSection.css';
import s2 from './Comment/Comment.css';
import Comment from './Comment/CommentContainer';
import comments from './comments';

export default function CommentsSectionPresentation({ isMobile }) {
  useStyles(s, s2);
  const longestComment = comments.reduce((a, b) => (a.text.length > b.text.length ? a : b));
  return (
    <section className={s.commentsContainer}>
      <h2>تپسی از نگاه همکاران</h2>
      <div className={s.carousel}>
        <Carousel
          autoPlay={false}
          navButtonsAlwaysVisible={!isMobile}
          NextIcon={<NavigateNextIcon color="action" fontSize="large" />}
          PrevIcon={<NavigateBeforeIcon color="action" fontSize="large" />}
          animation="slide"
        >
          {comments.map((comment) => (
            <div className={s.relativeContainer}>
              <div className={s.hiddenContainer}>
                <div className={s2.commentHeader}>
                  <img src={longestComment.profileImage} alt="profile" className={s2.profileImage} width="64px" height="64px" />
                  <div>
                    <div className={s2.name}>{longestComment.name}</div>
                    <div className={s2.jobTitle}>{longestComment.jobTitle}</div>
                  </div>
                </div>
                <p className={s.description}>{longestComment.text}</p>
              </div>
              <Comment
                name={comment.name}
                profileImageWebp={comment.profileImageWebp}
                profileImageJpg={comment.profileImageJpg}
                jobTitle={comment.jobTitle}
                commentText={comment.text}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
}

CommentsSectionPresentation.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};
